import { z } from "zod";

export const settingsSchema = z.object({
  firstname: z.string().min(1, "Please enter your firstname"),
  lastname: z.string().min(1, "Please enter your lastname"),
  addressline1: z.string().min(1, "Please enter your address"),
  addressline2: z.string().optional(),
  addressline3: z.string().optional(),
  towncity: z.string().min(1, "Please enter your town or city"),
  countystate: z.string().min(1, "Please enter your county"),
  postzipcode: z.string().min(1, "Please enter a postcode"),
  phonenumber: z.string().optional(),
  countrycode: z.string().min(1, "Please select a country"),
});

export type SettingsFormValues = z.infer<typeof settingsSchema>;
